import { render, staticRenderFns } from "./block-organization-billing.vue?vue&type=template&id=288bdc2a&scoped=true&lang=pug"
import script from "./block-organization-billing.vue?vue&type=script&lang=js"
export * from "./block-organization-billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bdc2a",
  null
  
)

export default component.exports